<!-- 薬剤師資格確認スライド -->
<!-- 親から渡される :inquiry.sync / :v$ / :current-slide-value はこのコンポーネントでは不要。
     defineProps で受け取らずに inheritAttrs: false でフォールスルーを無効化し、
     DOM 属性への漏れ（"Invalid qualified name: 'v$'" 等）を防ぐ。
     Vue 2.7 では defineOptions が存在しないため、別の <script> ブロックで指定する。 -->
<script lang="ts">
export default { inheritAttrs: false };
</script>

<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';

/** カスタムイベント */
const emit = defineEmits(['next']);

/** 資格選択肢 */
const licenseOptions = [
  { value: 'pharmacist', text: '薬剤師' },
  { value: 'certified_pharmacist', text: '認定薬剤師' },
  { value: 'no_license', text: '資格なし' },
];

/** 選択された資格 */
const selectedLicense = ref<string | null>(null);

/** 資格なしを選択しているか */
const isNoLicense = computed(() => selectedLicense.value === 'no_license');

/** 「次へ」ボタン */
const nextButton = ref<HTMLButtonElement | null>();

/** バリデーションが無効か */
const invalid = computed(() => selectedLicense.value === null || isNoLicense.value);

// 資格選択時に自動遷移
watch(selectedLicense, async (newValue) => {
  if (newValue && newValue !== 'no_license') {
    await nextTick();
    nextButton.value?.click();
  }
});
</script>

<template>
  <div class="slide_body">
    <div class="option_wrap">
      <h3 class="option_title required">保有資格を教えてください</h3>
      <div class="option_group">
        <div
          v-for="option in licenseOptions"
          :key="option.value"
          class="option_input"
        >
          <input
            :id="`license_${option.value}`"
            v-model="selectedLicense"
            type="radio"
            name="pharmacist_license"
            :value="option.value"
            required
          >
          <label
            :for="`license_${option.value}`"
          >{{ option.text }}</label>
        </div>
      </div>
      <div
        v-if="isNoLicense"
        class="validation_message_box no_license_message"
      >
        <span class="underline">薬剤師資格保持者限定サービスのため、ご利用いただけません。</span>
      </div>
    </div>
    <div class="slide_control_group">
      <button
        id="ph_next_license_check"
        ref="nextButton"
        :disabled="invalid"
        class="form_button form_button_small next_button"
        @click="emit('next')"
      >
        次へ
      </button>
    </div>
  </div>
</template>
